import { useState, useEffect } from "react";
import { Link } from "react-scroll";
import styles from './NavBar.module.css';

import StickyContainer from "components/StickyContainer";

const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

const NavItems = (props: { alphabetisedPlaces: any; closeMenu: any }) => (
  <ul>
    {alphabet.map((letter) => {
      if (letter in props.alphabetisedPlaces)
        return (
          <li key={letter}>
            <Link to={`startsWith_${letter}`} smooth={true} offset={-200} duration={500} onClick={props.closeMenu}>
              {letter.toUpperCase()}
            </Link>
          </li>
        );
      else
        return (
          <li key={letter}>
            <p>{letter.toUpperCase()}</p>
          </li>
        );
    })}
  </ul>
);

const NavBar = (props) => {
  const [windowWidth, updateWindowWidth] = useState<number>(0);

  const updateWindow = () => {
    updateWindowWidth(window.innerWidth);
  };

  const closeMenu = (e) => {
    if (props.menuVisible) {
      props.closeMenu();
    }
  };

  useEffect(() => {
    updateWindow();
    window.addEventListener("resize", updateWindow);

    return () => {
      window.removeEventListener("resize", updateWindow);
    };
  });

  useEffect(() => {
    let overlay = document.getElementById('overlay');
    let menu = document.getElementById('cr-NEW-menu');
    if (overlay && menu) {
      if (props.menuVisible) {
        overlay.style.opacity = '1';
        menu.style.opacity = '1';
      } else {
        overlay.style.opacity = '0';
        menu.style.opacity = '0';
      }
    }
  }, [props.menuVisible]);

  if (windowWidth >= 968)
    return (
      <StickyContainer offsetFromTop={70}>
        <div className={styles.Background}>
          <div className={styles.Container}>
            <NavItems {...props} closeMenu={closeMenu} />
          </div>
        </div>
      </StickyContainer>
    );

  return (
    <>
      <div className={styles.Overlay}
        id="overlay"
        style={{
          display: props.menuVisible ? "block" : "none",
        }}
        onClick={(e) => {
          props.closeMenu();
        }}
      />
      <section className={styles.SideMenu}
        id="cr-NEW-menu"
        style={{
          display: props.menuVisible ? "block" : "none",
        }}
      >
        <NavItems {...props} closeMenu={closeMenu} />
      </section>
    </>
  );
};

export default NavBar;
